import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import parse from 'html-react-parser';
import sanitize from 'sanitize-html';
import { patchImageUrl } from '@culture/common-helpers/cultureUtils';

import Icon from 'components/Icon';
import { ImageFormatContext } from 'contexts/ImageFormatContext';
import LazyLoadImage from 'components/LazyLoad/Image';

import styles from './styles.module.scss';

const Quote = ({ description, text, thumbnail }) => {
	const imageFormat = useContext(ImageFormatContext);

	const parsedQuoteText = parse(sanitize(text));
	const imageSrc = patchImageUrl(thumbnail, { format: imageFormat });

	return (
		<div className={cx(styles.quote, { [styles.hasImage]: !!imageSrc })}>
			{imageSrc && (
				<LazyLoadImage
					className={styles.imageWrapper}
					imageSrc={imageSrc}
					placeholder={
						<div className={cx(styles.imageWrapper, styles.placeholder)} />
					}
				>
					<img alt="" src={imageSrc} className={styles.image} />
				</LazyLoadImage>
			)}
			<div>
				<div className={styles.text}>{parsedQuoteText}</div>
				{description && <div className={styles.description}>{description}</div>}
			</div>
			<Icon icon="quoteLeft" className={cx(styles.icon, styles.iconLeft)} />
			<Icon icon="quoteLeft" className={cx(styles.icon, styles.iconRight)} />
		</div>
	);
};

Quote.propTypes = {
	text: PropTypes.string.isRequired,
	description: PropTypes.string,
	thumbnail: PropTypes.string
};

export default Quote;
